import { h } from 'vue';
import { ElDatePicker, dayjs } from 'element-plus';
import {
  adaptDateFormat,
  adaptDefaultTime,
  dateToTimestamp,
  timestampToDate
} from '../../util/datePickerAdapter';

export default {
  name: 'CompatibleDatePicker',
  inheritAttrs: false,
  props: {
    modelValue: { type: [Date, String, Number, Array], default: undefined },
    value: { type: [Date, String, Number, Array], default: undefined },
    valueFormat: String,
    format: String,
    defaultTime: [Date, String, Array],
    pickerOptions: { type: Object, default: () => ({}) },
    disabledDate: Function,
    shortcuts: Array
  },
  emits: ['update:modelValue', 'input', 'change', 'calendar-change'],
  computed: {
    pickerValue() {
      const value = this.modelValue !== undefined ? this.modelValue : this.value;
      return this.valueFormat === 'timestamp' ? timestampToDate(value) : value;
    },
    compatibleShortcuts() {
      if (this.shortcuts !== undefined) return this.shortcuts;
      const shortcuts = this.pickerOptions && this.pickerOptions.shortcuts;
      if (!shortcuts) return undefined;
      return shortcuts.map(shortcut => {
        if (!shortcut.onClick) return shortcut;
        return {
          ...shortcut,
          onClick(context) {
            return shortcut.onClick({
              ...context,
              $emit(event, value, ...args) {
                const pickedValue = event === 'pick' && value != null
                  ? (Array.isArray(value) ? value.map(date => dayjs(date)) : dayjs(value))
                  : value;
                return context.emit(event, pickedValue, ...args);
              }
            });
          }
        };
      });
    }
  },
  methods: {
    toBusinessValue(value) {
      return this.valueFormat === 'timestamp' ? dateToTimestamp(value) : value;
    },
    onModelValueUpdate(value) {
      const businessValue = this.toBusinessValue(value);
      this.$emit('update:modelValue', businessValue);
      this.$emit('input', businessValue);
    },
    onChange(value) {
      this.$emit('change', this.toBusinessValue(value));
    },
    onCalendarChange(value) {
      const options = this.pickerOptions;
      if (options && typeof options.onPick === 'function') {
        options.onPick({ minDate: value && value[0], maxDate: value && value[1] });
      }
      this.$emit('calendar-change', value);
    },
    focus(...args) {
      return this.$refs.picker && this.$refs.picker.focus(...args);
    },
    blur(...args) {
      return this.$refs.picker && this.$refs.picker.blur(...args);
    },
    handleOpen(...args) {
      return this.$refs.picker && this.$refs.picker.handleOpen(...args);
    },
    handleClose(...args) {
      return this.$refs.picker && this.$refs.picker.handleClose(...args);
    }
  },
  render() {
    return h(ElDatePicker, {
      ...this.$attrs,
      ref: 'picker',
      modelValue: this.pickerValue,
      valueFormat: this.valueFormat === 'timestamp' ? undefined : adaptDateFormat(this.valueFormat),
      format: adaptDateFormat(this.format),
      defaultTime: adaptDefaultTime(this.defaultTime),
      disabledDate: this.disabledDate !== undefined
        ? this.disabledDate
        : this.pickerOptions && this.pickerOptions.disabledDate,
      shortcuts: this.compatibleShortcuts,
      'onUpdate:modelValue': this.onModelValueUpdate,
      onChange: this.onChange,
      onCalendarChange: this.onCalendarChange
    }, this.$slots);
  }
};
